import { EntityBase } from './EntityBase';
import { TypeLinkTarget } from './TypeLinkTarget';
import { RIFMDocumentFolder } from './RIFMDocumentFolder';
import { TypeRIFMDocument } from './TypeRIFMDocument';
import { Reference } from './Reference';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class RIFMDocumentArchive extends EntityBase {

    /// <code> Place custom code between <code> tags

    /// </code>

    // Generated code. Do not place code below this line.
    rIFMDocumentArchiveId: number;
    typeRIFMDocumentId: string;
    rIFMDocumentFolderId: number;
    referenceId: number;
    fileName: string;
    originalFileName: string;
    notes: string;
    changeHistory: string;
    created: Date;
    createdUser: string;
    modified: Date;
    modifyUser: string;
    rowVersion: number;
    rIFMDocumentFolder: RIFMDocumentFolder;
    typeRIFMDocument: TypeRIFMDocument;
    reference: Reference;
}
